import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Thesis} from 'shared/classes/thesis';

@Injectable()
export class ThesisDetailsRepository {

  constructor(private http: Http) { }

  public getThesisById(id: string): Observable<Thesis> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(`${environment.theses}/${id}?withRating=true`, options)
      .map((thesis: Response) => {
        return thesis.json();
      });
  }

  public saveThesis(thesis: Thesis): Observable<Thesis> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(thesis);

    return this.http.post(environment.theses, body, options)
      .map((createdThesis: Response) => {
        return createdThesis.json();
      });
  }

  public updateThesis(thesis: Thesis): Observable<Thesis> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(thesis);

    return this.http.put(`${environment.theses}/${thesis._id}`, body, options)
      .map((updatedThesis: Response) => {
        return updatedThesis.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-details/repositories/thesis-details.repository.ts